import { useMemo } from 'react'
import { useEventListener } from './useEventListener'

const createKeyPredicate = keyFilter =>
  typeof keyFilter === 'function'
    ? keyFilter
    : typeof keyFilter === 'number'
    ? event => event.keyCode === keyFilter
    : keyFilter
    ? () => true
    : () => false

export const useKeyPress = (key, fn = () => {}, opts = {}, deps = []) => {
  const { event = 'keydown', target, options } = opts

  const useMemoHandler = useMemo(() => {
    const predicate = createKeyPredicate(key)

    const handler = handlerEvent => {
      if (predicate(handlerEvent)) {
        return fn(handlerEvent)
      }
    }

    return handler
  }, [...deps, key])

  useEventListener(event, useMemoHandler, target, options)
}
